var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHandHoldingHeartColorinline = function SvgHandHoldingHeartColorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_1402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.556 8.809a.606.606 0 0 0 .885 0l3.753-3.965c1.094-1.15 1.032-3.06-.196-4.122-1.072-.929-2.665-.76-3.642.268l-.387.403L9.61.989C8.636-.04 7.038-.208 5.941.72c-1.194 1.063-1.264 2.973-.163 4.123l3.778 3.965Z",
    fill: "#C8AF6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.73 11.788a1.385 1.385 0 0 0-1.943-.294l-4.156 3.062H9.443a.526.526 0 0 1-.524-.525c0-.303.252-.524.524-.524h2.717c.525 0 1.068-.377 1.16-.924a1.127 1.127 0 0 0-1.099-1.298H6.635c-.906 0-1.844.321-2.573.912l-1.615 1.31H.525c-.304 0-.525.252-.525.555v3.271c0 .306.252.556.524.556h12.018c.765 0 1.525-.25 2.142-.704l4.691-3.455a1.35 1.35 0 0 0 .354-1.942Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_1402"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .111)",
    d: "M0 0h20v17.778H0z"
  })))));
};

export default SvgHandHoldingHeartColorinline;